module.exports = __webpack_public_path__ + "img/bader_logo_small.666f459d.png";